<div [title]="'approvalMatrixModal.title' | translate">
  <svg-icon class="approval-matrix-dialog-close" src="./assets/icons/close-outline.svg" (click)="closeApprovalMatrix()"></svg-icon>
  <p class="approval-header-text">{{ 'approvalMatrixModal.approveOrReject' | translate }}</p>
  <p class="approval-header-info-text">{{ 'approvalMatrixModal.commentsWillBeSaved' | translate }}</p>

  <div class="approval-dropdowns-container" *ngIf="isGeneralTask">
    <div class="approval-dropdown-container">
      <label for="businessUnitDropdown"><a style="color: #E66360;">*&nbsp;</a>{{ 'approvalMatrixModal.businessUnits' | translate }}</label>
      <kendo-dropdownlist class="approval-matrix-dropdown" [data]="this.currentUser.BusinessUnits" [(ngModel)]="selectedBU" [valuePrimitive]="true"
                          [textField]="'displayName'" [valueField]="'oid'" (ngModelChange)="validate()">
      </kendo-dropdownlist>
    </div>

    <div class="approval-dropdown-container">
      <label for="regionalGroupDropdown">{{ 'approvalMatrixModal.regionalGroups' | translate }}</label>
      <kendo-dropdownlist class="approval-matrix-dropdown" [data]="regionalGroups" [(ngModel)]="selectedRegionalGroup" [valuePrimitive]="true"
                          [textField]="'description_en_US'" [valueField]="'oid'">
      </kendo-dropdownlist>
    </div>
  </div>

  <div class="ContentContainer">
    <table class="approval-table" aria-hidden="true">
      <tr>
        <td>
          <textarea class="approval-matrix-textarea" id="approvalMatrixComment" resizable="none"
                    [(ngModel)]="approvalComment" placeholder="{{ 'approvalMatrixModal.placeholder' | translate }}"></textarea>
        </td>
      </tr>
    </table>
  </div>

  <div class="approval-matrix-dialog-bar">
    <div class="reportDesignerButtonBarBorder">
      <div class="ButtonBar approval-matrix-footer-buttons">
        <div class="approval-matrix-footer-buttons">
          <button class="approval-matrix-btn-approved" (click)="approve()" [ngClass]="isGeneralTask && isDisabled ? 'disabled': ''">
            {{ 'raci.participantsAssignment.approve' | translate }}
          </button>

          <button class="approval-matrix-btn-reject" (click)="reject()">
            {{ 'raci.participantsAssignment.reject' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
